import { useContext, useMemo } from "react";
import { ObjectSchema, number, object } from "yup";
import { AvisConstants } from "../../../../../data/avisConstants";
import { LicenseInvoicePlanBriefInfo } from "../../../../../generated/data-contracts";
import { IFilterProps } from "../../../../../models";
import { IAxiosError, api } from "../../../../../utils";
import { AvisFilterableTable } from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  columnConfigLicenseReports,
  conditionalFormattingReportDue,
} from "../ColumnConfigLicenseReports";

interface IActualReportsForLicenseGridProps {
  licenseId: number;
  archive: boolean;
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
}
export function ActualReportsForLicenseGrid(
  props: Readonly<IActualReportsForLicenseGridProps>,
) {
  const { licenseId, archive, setError } = props;
  const { res } = useContext(AvisContext);

  const columnMetadata = columnConfigLicenseReports(licenseId, res);

  const tableColWidths = useMemo(() => [20, 20, 15, 45], []);
  const validationSchema: ObjectSchema<IFilterProps> = object({
    pageIndex: number().min(0),
    pageSize: number().min(1),
  });

  return (
    <AvisFilterableTable<LicenseInvoicePlanBriefInfo, IFilterProps>
      defaultFilterValues={{ pageIndex: 0, pageSize: 10 }}
      filterSessionKey={AvisConstants.licenses_reports_active_filter_values_key}
      setError={setError}
      filterValidationSchema={validationSchema}
      getApiData={(filter) => {
        return archive
          ? api.licenseesGetArchivedReportsForLicense(licenseId, filter as any)
          : api.licenseesGetActiveReportsForLicense(licenseId, filter as any);
      }}
      renderFilter={() => <></>}
      tableColumns={columnMetadata}
      tableColumnWidths={tableColWidths}
      conditionalFormatting={!archive ? [conditionalFormattingReportDue] : []}
    />
  );
}
